module.exports = __webpack_public_path__ + "media/images/group-80f3c15f68c718beddea56208f15025f.svg";